import { registerPlugin } from '@capacitor/core';
import type { AzureOAuthPlugin } from './definitions';

const AzureOAuthNative: AzureOAuthPlugin = registerPlugin<AzureOAuthPlugin>('AzureOAuthPlugin');

export * from './definitions';
export { AzureOAuthNative };
